import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// ---------- Movie & Geo ----------
export const fetchMovie = async () => (await api.get("/movie")).data;
export const fetchGeo = async () => (await api.get("/geo")).data;
export const overrideRegion = async (region) =>
  (await api.post("/geo/override", { region })).data;
export const overrideCountry = async (country_code) =>
  (await api.post("/geo/override", { country_code })).data;

// ---------- Payment ----------
export const createOrder = async (amount, currency) =>
  (await api.post("/payment/create-order", { amount, currency })).data;

export const verifyPayment = async (payload) =>
  (await api.post("/payment/verify", payload)).data;

export const recoverPayment = async () =>
  (await api.post("/payment/recover")).data;

export const saveProfile = async ({ name, city, phone }) =>
  (await api.post("/profile", { name, city, phone })).data;

// ---------- Google Auth (Emergent) ----------
export const exchangeSession = async (session_id, pending_paid_email) =>
  (await api.post("/auth/session", { session_id, pending_paid_email })).data;

export const fetchMe = async () => (await api.get("/auth/me")).data;

export const logoutRequest = async () => {
  try {
    await api.post("/auth/logout");
  } catch {
    /* best-effort */
  }
};

// ---------- Watch Sessions (concurrent device control) ----------
export const watchStart = async (device_id) =>
  (await api.post("/watch/start", { device_id })).data;

export const watchHeartbeat = async (watch_session_id) =>
  (await api.post("/watch/heartbeat", { watch_session_id })).data;

export const watchEnd = async (watch_session_id) => {
  try {
    await api.post("/watch/end", { watch_session_id });
  } catch {
    /* best-effort */
  }
};

// ---------- Tips ----------
export const createTipOrder = async (email, amount, currency) =>
  (await api.post("/tip/create-order", { email, amount, currency })).data;

export const verifyTip = async (payload) =>
  (await api.post("/tip/verify", payload)).data;

// ---------- Local hints ----------
const EMAIL_KEY = "bck_email";
const NAME_KEY = "bck_name";
const DEVICE_KEY = "bck_device_id";
const PENDING_PAID_EMAIL_KEY = "bck_pending_paid_email";

export const rememberEmail = (email) => localStorage.setItem(EMAIL_KEY, email);
export const rememberName = (name) => {
  if (name) localStorage.setItem(NAME_KEY, name);
};
export const getEmail = () => localStorage.getItem(EMAIL_KEY);
export const getName = () => localStorage.getItem(NAME_KEY);

export const getOrCreateDeviceId = () => {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id =
      (window.crypto?.randomUUID && window.crypto.randomUUID()) ||
      `dev_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
};

export const setPendingPaidEmail = (email) => {
  if (email) sessionStorage.setItem(PENDING_PAID_EMAIL_KEY, email);
};
export const popPendingPaidEmail = () => {
  const v = sessionStorage.getItem(PENDING_PAID_EMAIL_KEY);
  if (v) sessionStorage.removeItem(PENDING_PAID_EMAIL_KEY);
  return v;
};

export const clearSession = async () => {
  await logoutRequest();
  localStorage.removeItem(EMAIL_KEY);
  localStorage.removeItem(NAME_KEY);
};

// ---------- Google sign-in trigger ----------
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleSignIn = (returnPath = "/watch") => {
  const redirectUrl = window.location.origin + returnPath;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
